/**Расширения изображений */
export const imageExtensions = ["gif", "jpg", "jpeg", "png", "svg", "webp"];
